/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { TelemetryBetaPage, TelemetryBetaPageProps } from '@/pages/TelemetryBeta/TelemetryBetaPage';

export function TelemetryBetaRoute({ adminMode }: TelemetryBetaPageProps) {
  return <TelemetryBetaPage adminMode={adminMode} />;
}
